import React, { useState } from "react";
import Sidebar from "../Components/Sidebar";
import { Outlet, useLocation, useNavigate } from "react-router";
import { CircleArrowLeft, Menu, PanelLeftClose } from "lucide-react";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { ROUTES } from "../routes/routePaths";

const PATH_TITLES = {
  [ROUTES.DASHBOARD_TABLE]: "Students",
  [ROUTES.DASHBOARD_FACULTY_MANAGEMENT]: "Faculty",
  [ROUTES.DASHBOARD_COURSE_MANAGEMENT]: "Courses",
  [ROUTES.DASHBOARD_BATCH_MANAGEMENT]: "Batches",
  [ROUTES.DASHBOARD_COURSE_CONTENT_MANAGEMENT]: "Course Content",
  [ROUTES.DASHBOARD_FEES_MANAGEMENT]: "Fees",
  [ROUTES.DASHBOARD_OFFER_MANAGEMENT]: "Offers",
  [ROUTES.DASHBOARD_STUDENT_MANAGEMENT]: "Students",
  [ROUTES.DASHBOARD_SUBSCRIPTION_MANAGEMENT]: "Subscriptions",
  [ROUTES.DASHBOARD_LOGIN_FORM]: "Login",
  [ROUTES.DASHBOARD_WEBINAR_MANAGEMENT]: "Events",
  [ROUTES.DASHBOARD_WEBINAR_REGISTRATIONS]: "Events registrations",
  [ROUTES.DASHBOARD_LECTURE_MANAGEMENT]: "Lectures",
  [ROUTES.DASHBOARD_BLOG_MANAGEMENT]: "Blogs",
  [ROUTES.DASHBOARD_PREBOOKING_PAYMENT]: "Prebooking & Payments",
  [ROUTES.DASHBOARD_VIDEO_REVIEW_MANAGEMENT]: "Video Reviews",
  [ROUTES.DASHBOARD_ENQUIRY_MANAGEMENT]: "Enquiries",
  [ROUTES.DASHBOARD_CHATBOT_QUERIES]: "Chatbot Queries",
};

function getPageTitle(pathname) {
  if (!pathname || pathname === "/") return "Dashboard";
  const segment = pathname.replace(/^\//, "");
  return PATH_TITLES[segment] || PATH_TITLES[`/${segment}`] || "Dashboard";
}

function DashboardLayout() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const pageTitle = getPageTitle(location.pathname);
  const mainMargin = isDesktop
    ? isOpen
      ? "lg:ml-64"
      : "lg:ml-[4.5rem]"
    : "ml-0";

  return (
    <div className="flex min-h-screen bg-[#0d1b2e]">
      <Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />

      <main
        className={`flex min-w-0 flex-1 flex-col transition-all duration-300 ${mainMargin}`}
      >
        <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-3 border-b border-[#1d3350] bg-[#0f1c2e]/95 px-4 shadow-sm backdrop-blur sm:px-6">
          <button
            type="button"
            onClick={() => setIsOpen((prev) => !prev)}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-800 text-white transition-colors hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-400"
            aria-label={isOpen ? "Collapse sidebar" : "Open sidebar"}
          >
            {isOpen ? (
              <PanelLeftClose size={20} aria-hidden />
            ) : (
              <Menu size={20} aria-hidden />
            )}
          </button>
          <h1 className="truncate text-lg font-semibold text-slate-200">
            {pageTitle}
          </h1>
        </header>

        <div className="flex-1 overflow-y-auto p-4 cursor-pointer sm:p-6">
          {!["/course-management","/blog-management"].includes(location.pathname) && (
            <div
              onClick={() => {
                navigate(-1);
              }}
              className="flex text-red-500/50 hover:text-red-500 underline-offset-4 mb-3 underline items-center  px-2 py-1 rounded-md w-fit gap-2"
            >
              <CircleArrowLeft size={24} />
              <span>back</span>
            </div>
          )}
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default DashboardLayout;